import { useState, useRef, useEffect } from "react";
import Toggle from "../toogle/toogle";
import "./Clientsettings.css";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdArrowDropUp, MdArrowDropDown } from "react-icons/md";

function Clientsettings({ newclient, SelectedClient, onChange, label }) {
  const [minimise, setMinimise] = useState({
    ticket: false,
    role_permissions: false,
    email_permissions: false,
    ReportDownload: false,
    approvals: false,
  });

  const [Ticket, setTicket] = useState(true);
  const [mdToggle, setMdToggle] = useState(true);
  const [createUserToggle, setCreateUserToggle] = useState(true);

  // Manager permissions
  const [managerPermissions, setManagerPermissions] = useState({
    createUser: true,
    modifyUser: true,
    shiftSchedule: true,
  });

  const [EmailPermission, setEmailPermissions] = useState({
    create: true,
    ticket_raise: true,
    ticket_reopen: true,
    ticket_close: true,
    ticket_hold: true,
  });

  const [ReportDownload, setReportDownload] = useState({
    emp_name: true,
    ticketNumber: true,
    ticket_tittle: true,
    ticket_des: true,
    contact: true,
    a1_details: true,
    a2_details: true,
    ticket_assigned_name: true,
    ticket_remarks: true,
    ticket_landed_time: true,
    ticket_created_time: true,
    ticket_closed_time: true,
    ticket_time_taken: true,
  });

  // Approval system
  const [approvalWorkflowEnabled, setApprovalWorkflowEnabled] = useState(false);
  const [approvalManager, setApprovalManager] = useState(false);
  const [approvalMD, setApprovalMD] = useState(false);

  const [newroles, setnewroles] = useState({
    roles: ["bh"],
  });

  // Normalize roles
  const rolesRaw = newroles?.roles || newclient?.roles;
  let roles = [];

  if (Array.isArray(rolesRaw)) {
    roles = rolesRaw;
  } else if (typeof rolesRaw === "string") {
    roles = rolesRaw.split(",").map((r) => r.trim());
  }

  const approvalManagerRole = roles.includes("cmanager");

  /** ----------------------------------------------------
   * ORIGINAL HANDLERS (RESTORED)
   * ---------------------------------------------------- */

  const handleManagerMainToggle = () => {
    const newState = !createUserToggle;
    setCreateUserToggle(newState);
    setManagerPermissions({
      createUser: newState,
      modifyUser: newState,
      shiftSchedule: newState,
    });
  };

  const handleManagerPermission = (key) => {
    setManagerPermissions((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleEmailPermission = (key) => {
    setEmailPermissions((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleReportDownload = (key) => {
    setReportDownload((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  /** ----------------------------------------------------
   * APPLY VALUES WHEN SELECTEDCLIENT CHANGES
   * ---------------------------------------------------- */
  useEffect(() => {
    if (!SelectedClient) return;

    setTicket(SelectedClient?.tic_status ?? false);

    // md toggle
    setMdToggle(SelectedClient?.role_permissions?.bh ?? false);

    // manager permissions
    const cmanager = {
      createUser: SelectedClient.role_permissions?.cmanager?.create ?? false,
      modifyUser: SelectedClient.role_permissions?.cmanager?.modify ?? false,
      shiftSchedule: SelectedClient.role_permissions?.cmanager?.shift ?? false,
    };

    setManagerPermissions(cmanager);

    const anyEnabled = Object.values(cmanager).some((v) => v === true);
    setCreateUserToggle(anyEnabled);

    // email permissions
    const email = {
      create: SelectedClient.email_permissions?.email_create ?? false,
      ticket_raise: SelectedClient.email_permissions?.email_raise ?? false,
      ticket_reopen: SelectedClient.email_permissions?.email_reopen ?? false,
      ticket_close: SelectedClient.email_permissions?.email_close ?? false,
      ticket_hold: SelectedClient.email_permissions?.email_hold ?? false,
    };
    setEmailPermissions(email);

    // report downloads
    const reports = {
      emp_name: true,
      ticketNumber: true,
      ticket_tittle: true,
      ticket_des: SelectedClient.report_downloads?.R_ticket_des ?? false,
      contact: SelectedClient.report_downloads?.R_contact ?? false,
      a1_details: SelectedClient.report_downloads?.R_a1_details ?? false,
      a2_details: SelectedClient.report_downloads?.R_a2_details ?? false,
      ticket_assigned_name:
        SelectedClient.report_downloads?.R_ticket_assigned_name ?? false,
      ticket_remarks:
        SelectedClient.report_downloads?.R_ticket_remarks ?? false,
      ticket_landed_time:
        SelectedClient.report_downloads?.R_ticket_landed_time ?? false,
      ticket_created_time:
        SelectedClient.report_downloads?.R_ticket_created_time ?? false,
      ticket_closed_time:
        SelectedClient.report_downloads?.R_ticket_closed_time ?? false,
      ticket_time_taken:
        SelectedClient.report_downloads?.R_ticket_time_taken ?? false,
    };
    setReportDownload(reports);

    // approval data
    const toBool = (v) => v === true || v === "true";

    const approvalCManager = toBool(
      SelectedClient?.tic_approval?.approval_cmanager
    );
    const approvalBH = toBool(SelectedClient?.tic_approval?.approval_bh);

    setApprovalManager(approvalCManager);
    setApprovalMD(approvalBH);
    setApprovalWorkflowEnabled(approvalCManager || approvalBH);

    // 🟢 FIX: CLONE ROLES (THIS WAS THE BUG)
    setnewroles({
      roles: Array.isArray(SelectedClient.roles)
        ? [...SelectedClient.roles] // FIXED HERE
        : [],
    });
  }, [SelectedClient]);

  /** ----------------------------------------------------
   * REPORT CHANGES
   * ---------------------------------------------------- */
  const prevSettings = useRef({});

  useEffect(() => {
    const currentSettings = {
      mdToggle,
      Ticket,
      createUserToggle,
      approvalManager,
      approvalMD,
      approvalWorkflowEnabled,
      managerPermissions,
      EmailPermission,
      ReportDownload,
      roles: newroles.roles.join(", "),
    };

    console.table(ReportDownload);
    const hasChanged =
      JSON.stringify(currentSettings) !== JSON.stringify(prevSettings.current);

    if (hasChanged && onChange) {
      onChange(currentSettings);
      prevSettings.current = currentSettings;
    }
  }, [
    mdToggle,
    createUserToggle,
    approvalManager,
    approvalMD,
    approvalWorkflowEnabled,
    managerPermissions,
    EmailPermission,
    ReportDownload,
    newroles.roles,
    onChange,
    Ticket,
  ]);

  /** ----------------------------------------------------
   * ROLE SELECT HANDLING (ORIGINAL)
   * ---------------------------------------------------- */

  const ROLE_MAP = {
    bh: "Business Head",
    cmanager: "Manager",
    user: "User",
  };

  const handleSelect = (e) => {
    const selectedRole = e.target.value;
    if (selectedRole && !newroles.roles.includes(selectedRole)) {
      setnewroles((pv) => ({
        ...pv,
        roles: [...pv.roles, selectedRole],
      }));
    }
  };

  const handleRemove = (role) => {
    if (role === "bh") return;

    setnewroles((pv) => ({
      ...pv,
      roles: pv.roles.filter((r) => r !== role),
    }));
  };

  return (
    <>
      {label && (
        <div>
          <p className="company-info">
            Client Name:&nbsp;<strong>{label}</strong>
          </p>
        </div>
      )}

      {SelectedClient?.roles && (
        <div>
          <span className="admin-portal-label">Add New Roles:</span>
          <div className="role-selector-container">
            <div className="selected-roles-container">
              {newroles.roles.map((roleCode) => (
                <div
                  key={roleCode}
                  className={`role-tag ${
                    roleCode === "bh" ? "fixed-role" : ""
                  }`}
                >
                  <span className="role-name">{ROLE_MAP[roleCode]}</span>

                  {roleCode !== "bh" && (
                    <IoCloseCircleOutline
                      className="remove-icon"
                      onClick={() => handleRemove(roleCode)}
                    />
                  )}
                </div>
              ))}
            </div>

            <select
              onChange={handleSelect}
              value=""
              className="admin-portal-input role-select-dropdown"
            >
              <option value="" disabled>
                Select Role
              </option>
              <option value="cmanager">Mananger</option>
              <option value="user">User</option>
            </select>
          </div>
        </div>
      )}

      {/* role permission Section */}
      <div className="client-settings-container">
        <div
          className="settings-header"
          onClick={() => {
            setMinimise((pv) => ({
              ...pv,
              role_permissions: !minimise?.role_permissions,
            }));
          }}
        >
          <div className="settings-titles">Role Permissions</div>
          <div className="settings-titles">
            {minimise?.role_permissions === true ? (
              <MdArrowDropDown />
            ) : (
              <MdArrowDropUp />
            )}
          </div>
        </div>
        {minimise?.role_permissions && (
          <>
            <div className="roles-section">
              {/* Business Head toggle */}
              {roles.includes("bh") && (
                <div className="role-item">
                  <div className="role-info">
                    <span className="role-name">Business Head</span>
                    <span className="role-desc">Full access and control</span>
                  </div>
                  <Toggle
                    isOn={mdToggle}
                    onChange={() => setMdToggle(!mdToggle)}
                  />
                </div>
              )}

              {/* Manager main toggle */}
              {roles.includes("cmanager") && (
                <div className="role-item">
                  <div className="role-info">
                    <span className="role-name">Manager</span>
                    <span className="role-desc">Department-level access</span>
                  </div>
                  <Toggle
                    isOn={createUserToggle}
                    onChange={handleManagerMainToggle}
                  />
                </div>
              )}
            </div>
            {/* Manager permissions */}
            {createUserToggle && roles.includes("cmanager") && (
              <>
                <div className="role-item">
                  <div className="role-info">
                    <span className="role-desc">
                      Access to create new users
                    </span>
                  </div>
                  <Toggle
                    isOn={managerPermissions.createUser}
                    onChange={() => handleManagerPermission("createUser")}
                  />
                </div>

                <div className="role-item">
                  <div className="role-info">
                    <span className="role-desc">Access to modify users</span>
                  </div>
                  <Toggle
                    isOn={managerPermissions.modifyUser}
                    onChange={() => handleManagerPermission("modifyUser")}
                  />
                </div>

                <div className="role-item">
                  <div className="role-info">
                    <span className="role-desc">
                      Access to change the shift schedule for users
                    </span>
                  </div>
                  <Toggle
                    isOn={managerPermissions.shiftSchedule}
                    onChange={() => handleManagerPermission("shiftSchedule")}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>

      {/* email permission Section */}
      <div className="client-settings-container">
        <div
          className="settings-header"
          onClick={() => {
            setMinimise((pv) => ({
              ...pv,
              email_permissions: !minimise?.email_permissions,
            }));
          }}
        >
          <div className="settings-titles">Email Permissions</div>
          <div className="settings-titles">
            {minimise?.email_permissions === true ? (
              <MdArrowDropDown />
            ) : (
              <MdArrowDropUp />
            )}
          </div>
        </div>
        {minimise?.email_permissions && (
          <div className="roles-section">
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">New User</span>
                <span className="role-desc">
                  Enable sending an email notification when a new user is
                  created
                </span>
              </div>
              <Toggle
                isOn={EmailPermission.create}
                onChange={() => handleEmailPermission("create")}
              />
            </div>

            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Raise</span>
                <span className="role-desc">
                  Enable email notification when a ticket is raised
                </span>
              </div>
              <Toggle
                isOn={EmailPermission.ticket_raise}
                onChange={() => handleEmailPermission("ticket_raise")}
              />
            </div>

            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Hold</span>
                <span className="role-desc">
                  Enable email notification when a ticket is put on hold
                </span>
              </div>
              <Toggle
                isOn={EmailPermission.ticket_hold}
                onChange={() => handleEmailPermission("ticket_hold")}
              />
            </div>

            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Closed</span>
                <span className="role-desc">
                  Enable email notification when a ticket is closed
                </span>
              </div>
              <Toggle
                isOn={EmailPermission.ticket_close}
                onChange={() => handleEmailPermission("ticket_close")}
              />
            </div>

            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Reopened</span>
                <span className="role-desc">
                  Enable email notification when a ticket is re-opened
                </span>
              </div>
              <Toggle
                isOn={EmailPermission.ticket_reopen}
                onChange={() => handleEmailPermission("ticket_reopen")}
              />
            </div>
          </div>
        )}
      </div>

      {/* Report Downloads Section */}
      <div className="client-settings-container">
        <div
          className="settings-header"
          onClick={() => {
            setMinimise((pv) => ({
              ...pv,
              ReportDownload: !minimise?.ReportDownload,
            }));
          }}
        >
          <div className="settings-titles">Report Downloads</div>
          <div className="settings-titles">
            {minimise?.ReportDownload === true ? (
              <MdArrowDropDown />
            ) : (
              <MdArrowDropUp />
            )}
          </div>
        </div>
        {minimise?.ReportDownload && (
          <div className="roles-section">
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Employee Name</span>
              </div>
              <Toggle
                isOn={ReportDownload.emp_name}
                onChange={() => handleReportDownload("emp_name")}
                disabled={true}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Number</span>
              </div>
              <Toggle
                isOn={ReportDownload.ticketNumber}
                onChange={() => handleReportDownload("ticketNumber")}
                disabled={true}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Error Tittle</span>
              </div>
              <Toggle
                isOn={ReportDownload.ticket_tittle}
                onChange={() => handleReportDownload("ticket_tittle")}
                disabled={true}
              />
            </div>

            {/* optional  */}
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Error Description</span>
              </div>
              <Toggle
                isOn={ReportDownload.ticket_des}
                onChange={() => handleReportDownload("ticket_des")}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Contact Number</span>
              </div>
              <Toggle
                isOn={ReportDownload.contact}
                onChange={() => handleReportDownload("contact")}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Approval 1 Details</span>
              </div>
              <Toggle
                isOn={ReportDownload.a1_details}
                onChange={() => handleReportDownload("a1_details")}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Approval 2 Details</span>
              </div>
              <Toggle
                isOn={ReportDownload.a2_details}
                onChange={() => handleReportDownload("a2_details")}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Assigned Name</span>
              </div>
              <Toggle
                isOn={ReportDownload.ticket_assigned_name}
                onChange={() => handleReportDownload("ticket_assigned_name")}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Remarks</span>
              </div>
              <Toggle
                isOn={ReportDownload.ticket_remarks}
                onChange={() => handleReportDownload("ticket_remarks")}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Landed Time</span>
              </div>
              <Toggle
                isOn={ReportDownload.ticket_landed_time}
                onChange={() => handleReportDownload("ticket_landed_time")}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Created Time</span>
              </div>
              <Toggle
                isOn={ReportDownload.ticket_created_time}
                onChange={() => handleReportDownload("ticket_created_time")}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Closed Time</span>
              </div>
              <Toggle
                isOn={ReportDownload.ticket_closed_time}
                onChange={() => handleReportDownload("ticket_closed_time")}
              />
            </div>
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">Ticket Time Taken</span>
              </div>
              <Toggle
                isOn={ReportDownload.ticket_time_taken}
                onChange={() => handleReportDownload("ticket_time_taken")}
              />
            </div>
          </div>
        )}
      </div>

      {/* Approval Method Section */}
      <div className="client-settings-container">
        <div
          className="settings-header"
          onClick={() => {
            setMinimise((pv) => ({ ...pv, approvals: !minimise?.approvals }));
          }}
        >
          <div className="settings-titles">
            Approval Method — Ticketing System
          </div>
          <div className="settings-titles">
            {minimise?.role_permissions === true ? (
              <MdArrowDropDown />
            ) : (
              <MdArrowDropUp />
            )}
          </div>
        </div>

        {minimise?.approvals && (
          <div className="roles-section">
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">
                  Enable Ticket Approval Workflow
                </span>
                <span className="role-desc">
                  Control whether support tickets require approval before being
                  raised.
                </span>
              </div>
              <Toggle
                isOn={approvalWorkflowEnabled}
                onChange={() =>
                  setApprovalWorkflowEnabled(!approvalWorkflowEnabled)
                }
              />
            </div>

            {approvalWorkflowEnabled && (
              <div className="roles-section" style={{ marginTop: "10px" }}>
                {approvalManagerRole && (
                  <div className="role-item">
                    <div className="role-info">
                      <span className="role-name">Approval Level 1</span>
                      <span className="role-desc">
                        Manager approval — visible in the admin portal.
                      </span>
                    </div>
                    <Toggle
                      isOn={approvalManager}
                      onChange={() => setApprovalManager(!approvalManager)}
                    />
                  </div>
                )}

                <div className="role-item">
                  <div className="role-info">
                    <span className="role-name">
                      {roles.includes("cmanager") && approvalManager
                        ? "Approval Level 2"
                        : "Approval"}
                    </span>
                    <span className="role-desc">
                      Business Head approval — visible in the admin portal.
                    </span>
                  </div>
                  <Toggle
                    isOn={approvalMD}
                    onChange={() => setApprovalMD(!approvalMD)}
                  />
                </div>

                {/* Dynamic Approval Status */}
                <div
                  className="role-item"
                  style={{
                    background: "#f8fafc",
                    borderLeft:
                      (approvalManagerRole ? approvalManager : true) &&
                      approvalMD
                        ? "4px solid #16a34a" // green
                        : "4px solid #facc15", // yellow
                  }}
                >
                  <div className="role-info">
                    {(approvalManagerRole ? approvalManager : true) &&
                    approvalMD ? (
                      <span
                        className="role-desc"
                        style={{ color: "#16a34a", fontWeight: "500" }}
                      >
                        ✅ Tickets will be raised to the admin portal after the
                        selected approval(s) are completed.
                      </span>
                    ) : (
                      <span
                        className="role-desc"
                        style={{ color: "#eab308", fontWeight: "500" }}
                      >
                        ⚠️ Tickets cannot be raised until the selected
                        approval(s) are completed.
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Ticket */}
      <div className="client-settings-container">
        <div
          className="settings-header"
          onClick={() => {
            setMinimise((pv) => ({
              ...pv,
              ticket: !minimise?.ticket,
            }));
          }}
        >
          <div className="settings-titles">Ticket Raise</div>
          <div className="settings-titles">
            {minimise?.role_permissions === true ? (
              <MdArrowDropDown />
            ) : (
              <MdArrowDropUp />
            )}
          </div>
        </div>

        {minimise?.ticket && (
          <div className="roles-section">
            {/* Ticket */}
            <div className="role-item">
              <div className="role-info">
                <span className="role-name">
                  When Ticket Raise is turned off, users lose permission to
                  raise support tickets.
                </span>
                {/* <span className="role-desc">Full access and control</span> */}
              </div>
              <Toggle isOn={Ticket} onChange={() => setTicket(!Ticket)} />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Clientsettings;
